import './api'; // loads the 'pendo' global object
import CaPendo from './caPendo';

const caPendo = new CaPendo();
caPendo.run();
